module.exports = __webpack_public_path__ + "img/sponsorA18.e08adb75.png";